import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CatalogsState } from './catalogs.models';

export const selectCatalogsState = createFeatureSelector<CatalogsState>('catalogs');

export const selectCatalogs = createSelector(selectCatalogsState, (state) => state.catalogs);

export const selectCatalogsLoading = createSelector(selectCatalogsState, (state) => state.loading);

export const selectCatalogsError = createSelector(selectCatalogsState, (state) => state.error);
